import React, { Component } from 'react';
import Avatar from 'material-ui/Avatar'
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';


class Header extends Component {
    logout = () => {
        this.props.auth.signOut();
    };

    render = () => {
        return (
            <header>
                <Toolbar>
                    <ToolbarGroup firstChild={true}/>
                    <ToolbarGroup>
                        <IconMenu
                            iconButtonElement={
                                <IconButton touch={true}>
                                    <Avatar src={this.props.user.photoURL}/>
                                 </IconButton>
                            }
                        >
                            <MenuItem primaryText="Log out" onClick={this.logout}/>
                        </IconMenu>
                    </ToolbarGroup>
                </Toolbar>
            </header>
        )
    };
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js